<template>
  <div>
    <v-card class="ma-3">
      <!-- <v-tabs
        v-model="tab"
        centered
        background-color="transparent"
        icons-and-text
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab @click="tabs = 0">
          Agroindustria
          <v-icon>mdi-factory</v-icon>
        </v-tab>

        <v-tab v-if="$route.query.CodAgroindustria" @click="tabs = 1">
          Projetos
          <v-icon>mdi-google-analytics</v-icon>
        </v-tab>
      </v-tabs> -->

      <!-- <v-tabs-items v-model="tab">
        <v-tab-item> -->
      <base-loading v-if="loading" />
      <div v-else class="content">
        <template>
          <v-card
            :class="{ 'card-success': cadastro, 'card-warn': !cadastro }"
            style="min-height: 60vh"
          >
            <h4 v-if="!cadastro" slot="header" class="card-title text-center">
              Edição de Agroindústria
            </h4>
            <h4 v-else slot="header" class="card-title text-center">
              Cadastro de Agroindústria
            </h4>
            <div class="clearfix" />
            <div>
              <v-form
                id="form"
                ref="form"
                v-model="valid"
                enctype="multipart/form-data"
                class="pa-3"
                lazy-validation
                @submit.prevent="updateProfile"
              >
                <v-card>
                  <v-list-item-content>
                    <v-card-title class="headline mx-auto">
                      Dados Pessoais
                    </v-card-title>
                    <v-row v-if="!loading" class="pa-3">
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.nomeFantasia"
                          label="Nome Fantasia *"
                          :rules="requiredRules"
                          required
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.razaoSocial"
                          label="Razão Social *"
                          :rules="requiredRules"
                          required
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete
                          v-model="form.porte"
                          autocomplete="autocomplete_off_hack_xfr4!k"
                          :rules="requiredRules"
                          :items="portes"
                          item-text="text"
                          item-value="value"
                          label="Porte *"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.code"
                          label="Código"
                          type="number"
                          clearable
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.cnpj"
                          v-mask="maskCnpj"
                          label="CNPJ *"
                          :rules="cnpjRules"
                          return-masked-value
                          required
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete
                          v-model="form.estado"
                          autocomplete="autocomplete_off_hack_xfr4!k"
                          label="Estado *"
                          :items="estado"
                          :rules="requiredRules"
                          item-text="Nome"
                          item-value="CodEstado"
                          required
                          @change="changeCidade"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete
                          v-model="form.cidade"
                          autocomplete="autocomplete_off_hack_xfr4!k"
                          label="Cidade *"
                          :loading="loadingCidades"
                          :items="cidade"
                          :rules="requiredRules"
                          item-text="Nome"
                          item-value="CodCidade"
                          :disabled="disableCidade"
                          required
                        />
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-model="form.logradouro"
                          label="Logradouro *"
                          required
                        />
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="form.numero"
                          label="Numero *"
                          required
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.bairro"
                          label="Bairro *"
                          :rules="requiredRules"
                          required
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.complemento"
                          label="Complemento"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.cep"
                          v-mask="maskCep"
                          type="text"
                          :rules="requiredRules"
                          label="CEP *"
                          required
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.email"
                          type="email"
                          :rules="emailRules"
                          label="E-mail *"
                          return-masked-value
                          required
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="form.telRes"
                          v-mask="maskTelRes"
                          :rules="[...requiredRules, ...telRules]"
                          label="Telefone Comercial *"
                          type="tel"
                          required
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="form.telCel"
                          v-mask="maskTelCel"
                          :rules="telRules"
                          label="Telefone Celular"
                          type="tel"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-autocomplete
                          v-model="form.projects"
                          multiple
                          autocomplete="autocomplete_off_hack_xfr4!k"
                          label="Projeto *"
                          :loading="loadingProjects"
                          :items="project"
                          :rules="requiredRules"
                          :disabled="disableProjects"
                          item-text="name"
                          item-value="id"
                          required
                        />
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-card>
                <v-card class="pa-0 px-5 pb-5">
                  <v-card-title class="headline mx-auto ma-2 px-0">
                    Logotipo
                  </v-card-title>
                  <crud-image-uploader
                    ref="form"
                    v-model="form.imagem"
                    dialog-title="Logotipo da Empresa"
                    :editable="editLogo"
                    no-data="img/no-avatar.jpg"
                    @delete="deleteCall"
                    @upload="editLogo = true"
                  />
                  <v-row justify="center">
                    <v-dialog
                      v-model="dialogRemoveLogo"
                      persistent
                      max-width="290"
                    >
                      <v-card>
                        <v-card-text
                          >Deseja remover o logotipo? Essa operação não poderá
                          ser desfeita!
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="green darken-1"
                            text
                            :disabled="buttonRemoveLogo"
                            @click="
                              () => {
                                form.imagem = tmpLogo
                                dialogRemoveLogo = false
                              }
                            "
                          >
                            Cancelar
                          </v-btn>
                          <v-btn
                            color="red darken-1"
                            text
                            :disabled="buttonRemoveLogo"
                            :loading="buttonRemoveLogo"
                            @click="
                              () => {
                                removeLogo()
                              }
                            "
                          >
                            Remover
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </v-card>
                <v-btn
                  type="submit"
                  :disabled="salvando"
                  :loading="salvando"
                  :color="
                    !$route.query.CodAgroindustria ? 'success' : 'warning'
                  "
                  form="form"
                >
                  {{ btnNome }}
                </v-btn>
                <router-link
                  :disabled="salvando"
                  :to="`/${$user.get().role}/agroindustrias`"
                >
                  <v-btn :disabled="salvando" color="error" class="ml-3">
                    Cancelar
                  </v-btn>
                </router-link>
              </v-form>
            </div>
          </v-card>
        </template>
      </div>
      <!-- </v-tab-item>

        <v-tab-item>
          <Project :agroindustry="form" />
        </v-tab-item>
      </v-tabs-items> -->
    </v-card>
  </div>
</template>
<script>
import { ENV_APP } from '../../../env'
import { validarCNPJ } from '../../utils/validacoes'
// import Project from '../project/index.vue'

export default {
  // components: {
  //   Project,
  // },
  data() {
    return {
      tab: 0,
      dialogRemoveLogo: false,
      buttonRemoveLogo: false,
      removedLogo: false,
      tmpLogo: '',
      salvando: false,
      loading: true,
      loadingCidades: false,
      editLogo: false,
      portes: [
        {
          text: 'Micro',
          value: 'Micro',
        },
        {
          text: 'Pequeno',
          value: 'Pequeno',
        },
        {
          text: 'Médio',
          value: 'Médio',
        },
        {
          text: 'Grande',
          value: 'Grande',
        },
      ],
      imgSrc: '',
      maskCnpj: '##.###.###/####-##',
      maskTelRes: '(##) ####-####',
      maskTelCel: '(##) # ####-####',
      maskCep: '##.###-###',
      emailRules: [v => /.+@.+/.test(v) || 'E-mail invalido'],
      telRules: [
        v => !v || v.length === 0 || v.length >= 10 || '* Número inválido',
      ],
      cnpjRules: [
        v => !!v || '* Obrigatório',
        v => validarCNPJ(v) || '* CNPJ inválido',
      ],
      requiredRules: [v => !!v || '* Obrigatório'],
      valid: null,
      disableCidade: true,
      btnNome: !this.$route.query.CodAgroindustria
        ? 'Salvar'
        : 'Salvar Alterações',
      defaultImage:
        'data:image/png;base64,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',
      form: {
        imagem: null,
        codAgroindustria: null, // codigo da agroindústria
        razaoSocial: '',
        nomeFantasia: '',
        cnpj: '',
        porte: '',
        telRes: '',
        telCel: '',
        estado: 0,
        cidade: 0,
        projects: [],
        bairro: '',
        logradouro: '',
        numero: '',
        complemento: '',
        cep: '',
        email: '',
      },
      estado: [{ Nome: 'Carregando', CodEstado: 0 }],
      cidade: [],
      cadastro: this.$route.query.CodAgroindustria === 0 ? 1 : 0,
      project: [{ name: 'Carregando', id: 1 }],
      projectsQauntity: 1,
      disableProjects: true,
      loadingProjects: true,
      availableProjects: ENV_APP.availableProjects,
    }
  },
  created() {
    if (this.$route.query.CodAgroindustria) {
      this.form.codAgroindustria = this.$route.query.CodAgroindustria
      this.formDados()
    } else {
      this.loadNewForm()
    }

    this.loadProjects()
  },
  methods: {
    deleteCall() {
      this.dialogRemoveLogo = true
      this.buttonRemoveLogo = false
    },
    loadNewForm() {
      this.loadEstado()
      this.loading = false
    },
    updateProfile() {
      this.$refs.form.validate()
      if (!this.valid) {
        return this.Swal.fire(
          'Atenção',
          'Preencha os itens obrigatórios sinalizados com ("*").',
          'warning',
        )
      } else {
        this.salvando = true
        if (this.form.codAgroindustria) {
          // ATUALIZAR DADOS AGROINDUSTRIA
          this.alert = false
          this.api.update
            .agroindustria(this.form.codAgroindustria, this.form)
            .then(() => {
              this.Swal.fire({
                title: 'Sucesso',
                text: 'Cadastro Atualizado',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                this.$router.push({
                  path: `/${this.$user.get().role}/agroindustrias`,
                })
              })
            })
            .catch(() => {
              this.salvando = false
            })
        } else {
          // CRIAR NOVA AGROINDUSTRIA
          this.api.save
            .agroindustria(this.form)
            .then(() => {
              this.Swal.fire({
                title: 'Sucesso',
                text: 'Cadastro Realizado',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                this.$router.push({
                  path: `/${this.$user.get().role}/agroindustrias`,
                })
              })
            })
            .catch(() => {
              this.salvando = false
            })
        }
      }
    },
    formDados() {
      this.api.get.agroindustria(this.form.codAgroindustria).then(data => {
        this.form.imagem = data.logotipo || null
        this.tmpLogo = data.logotipo || null
        this.form.porte = data.agroindustria.Porte
        this.form.email = data.agroindustria.pessoa.email
        this.form.razaoSocial =
          data.agroindustria.pessoa.pessoajuridica.RazaoSocial
        this.form.nomeFantasia =
          data.agroindustria.pessoa.pessoajuridica.NomeFantasia
        this.form.cnpj = data.agroindustria.pessoa.pessoajuridica.Cnpj
        this.form.telRes = data.agroindustria.pessoa.TelRes
        this.form.telCel = data.agroindustria.pessoa.TelCel
        this.form.bairro = data.agroindustria.pessoa.endereco.Bairro
        this.form.cep = data.agroindustria.pessoa.endereco.Cep
        this.form.complemento = data.agroindustria.pessoa.endereco.Complemento
        this.form.logradouro = data.agroindustria.pessoa.endereco.Logradouro
        this.form.numero = data.agroindustria.pessoa.endereco.Numero
        this.form.cidade = data.agroindustria.pessoa.endereco.cidade.CodCidade
        this.form.estado =
          data.agroindustria.pessoa.endereco.cidade.estado.CodEstado
        this.form.projects = data.agroindustria.projects.map(p => {
          return {
            id: p.projectId,
          }
        })
        this.form.code = data.agroindustria.code ?? null
        this.loadEstado()
        this.loadCidade(this.form.estado)
        this.loading = false
      })
    },
    loadProjects() {
      this.api.get.projects().then(data => {
        this.project = data.filter(p => {
          if (this.availableProjects.includes(p.slug)) return p
        })
        this.disableProjects = false
        this.loadingProjects = false
      })
    },
    loadEstado() {
      this.api.get.estados().then(data => {
        this.estado = data
      })
    },
    loadCidade(CodEstado) {
      this.loadingCidades = true
      this.api.get.cidades(CodEstado).then(data => {
        this.cidade = data
        this.disableCidade = false
        this.loadingCidades = false
      })
    },
    changeCidade() {
      this.loadCidade(this.form.estado)
    },

    removeLogo() {
      this.buttonRemoveLogo = true

      if (this.removedLogo) {
        this.dialogRemoveLogo = false
        this.Swal.fire({
          title: 'Sucesso',
          text: 'Logo removida com sucesso.',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000,
        })

        return
      }

      this.removedLogo = true

      this.api.delete
        .deleteLogo(this.form.codAgroindustria)
        .then(() => {
          this.dialogRemoveLogo = false
          this.Swal.fire({
            title: 'Sucesso',
            text: 'Logo removida com sucesso.',
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          })
        })
        .catch(() => {
          this.dialogRemoveLogo = false
          this.Swal.fire({
            title: 'Sucesso',
            text: 'Erro ao remover logo.',
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          })
        })
    },
  },
}
</script>
<style>
html {
  overflow: auto !important;
}

input[type='file'] {
  display: none;
}

#foto {
  background-color: #3498db;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  padding: 6px 20px;
}

.index {
  z-index: 1;
}
</style>

<style>
.v-tab--active .v-icon {
  color: #003677 !important;
}
</style>
